export const BASEURL = "https://www.api.nurserylittlelambs.com/";
// export const BASEURL = "http://localhost:5000/"


export const successToast = {
  position: "bottom-center",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}
export const errorToast = {
  position: "bottom-center",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}
export const warningToast = {
  position: "bottom-center",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

